'use client';

import { getCookie, setCookie } from 'cookies-next';
import { useSyncExternalStore } from 'react';

import { Button } from './ui/button';

let listeners: Set<() => void> = new Set();

export function CookieConsent() {
  const USER_CONSENT_COOKIE_KEY = 'cookie_consent';
  const USER_CONSENT_MAX_AGE = 365 * 24 * 60 * 60; // 365 days in seconds

  const consented = useSyncExternalStore(
    (listener: () => void) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => getCookie(USER_CONSENT_COOKIE_KEY) === 'true',
    () => false,
  );

  async function onConsent() {
    await setCookie(USER_CONSENT_COOKIE_KEY, 'true', { maxAge: USER_CONSENT_MAX_AGE });
    listeners.forEach((listener) => listener());
  }

  if (consented) return null;

  return (
    <div className='pointer-events-none fixed inset-x-0 bottom-0 px-6 pb-6'>
      <div className='pointer-events-auto max-w-sm rounded-lg bg-white p-6 shadow-lg ring-1 ring-gray-900/10'>
        <p className='text-sm leading-6 text-gray-900'>
          By using this website, you agree to our use of cookies. We use cookies to provide you with a great experience
          and to help our website run effectively.
        </p>
        <div className='mt-4 flex items-center gap-x-5'>
          <Button variant='link' onClick={onConsent}>
            OK
          </Button>
        </div>
      </div>
    </div>
  );
}
